import { useEffect, useState } from 'react';

/**
 * Segundos até a próxima meia-noite no fuso America/Sao_Paulo (BRT) — o boundary
 * diário do sistema. Usa o relógio de parede via Intl pra não depender de DST.
 */
function secondsUntilBrtMidnight(): number {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Sao_Paulo',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).formatToParts(new Date());
  const get = (t: string): number => Number(parts.find((p) => p.type === t)?.value ?? '0');
  let h = get('hour');
  if (h === 24) h = 0; // alguns ambientes retornam 24 à meia-noite
  const elapsed = h * 3600 + get('minute') * 60 + get('second');
  return Math.max(0, 86_400 - elapsed);
}

function fmt(total: number): string {
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  return [h, m, s].map((n) => String(n).padStart(2, '0')).join(':');
}

/** Contador regressivo até a reposição diária (00:00 horário de Brasília). */
export function DailyResetCountdown() {
  const [secs, setSecs] = useState(secondsUntilBrtMidnight);
  useEffect(() => {
    const id = setInterval(() => setSecs(secondsUntilBrtMidnight()), 1000);
    return () => clearInterval(id);
  }, []);
  return <span className="tabular-nums">{fmt(secs)}</span>;
}
